export class ProductGroup {

    private id: string;
    private label: string | null;

    constructor(
        id: string,
        label: string | null
    ) {
        this.id = id;
        this.label = label;
    }

    public getId(): string {
        return this.id;
    }

    public setId(id: string): void {
        this.id = id;
    }

    public getLabel(): string | null {
        return this.label;
    }

    public setLabel(label: string | null): void {
        this.label = label;
    }

}